import { a6 as generateHTMLFromTemplate, a7 as replaceChildWithHTML, a8 as initCustomDropdown, a9 as getSelectedDropdownValue, Y as showAlertDialog, a as addClass, aa as updateBirthday, f as removeClass, b as setDataAttr, p as setText, ab as fetchRewards, q as qs, u as greetingText, c as click, z as qsa, h as hasClass, g as getAttr, ac as fadeIn } from './app-chunk-common-BPZAsnhF.js';
import { o as openRewardHistory, i as openCartDrawer } from './app-chunk-utils-4zL9DDjt.js';
import './app-bundle.vendor.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

const formSelector$1 = ".campaign-box__form";
const formTemplateSelector = "#campaignBirthdayForm";

const dayDropdownSelector = ".is-birthday-day";
const monthDropdownSelector = ".is-birthday-month";

const validateBirthdate = (day, month) => {
  day = parseInt(day);
  month = parseInt(month);

  // Zero based
  const jsMonth = month - 1;
  const date = new Date();
  date.setMonth(jsMonth);
  date.setDate(day);

  return date.getMonth() === jsMonth;
};

var initBirthdayForm = async (box) => {
  const data = {};
  const form = box.querySelector(formSelector$1);
  const html = generateHTMLFromTemplate(data, formTemplateSelector);
  replaceChildWithHTML(form, html);

  const dayDropdown = box.querySelector(dayDropdownSelector);
  const monthDropdown = box.querySelector(monthDropdownSelector);

  initCustomDropdown(dayDropdown);
  initCustomDropdown(monthDropdown);

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const day = getSelectedDropdownValue(dayDropdownSelector);
    const month = getSelectedDropdownValue(monthDropdownSelector);

    if (!day || !month) {
      showAlertDialog("Please enter your birthday");
      return;
    }

    if (!validateBirthdate(day, month)) {
      showAlertDialog("Not a real birthday, check the day of the month");
    }

    addClass(form, "is-saving");

    window.setTimeout(async () => {
      try {
        const res = await updateBirthday(window.ShopifyCustomerId, day, month);
        removeClass(box, "has-form");
        addClass(box, "is-completed");
        showAlertDialog("Thanks! You'll receive points on your birthday!");
      } catch (e) {
        removeClass(form, "is-saving");
        console.log("ERROR Updating birthday", e);
        showAlertDialog(
          "Whoops! Something went wrong, please try again a little later"
        );
      }
    }, 4000);
  });
};

const btnSelector = ".campaign-box__action-btn";
const formSelector = ".campaign-box__form";
const ctaFormClass = "is-cta-form";

var initCTAForm = (box, campaignData) => {
  const btn = box.querySelector(btnSelector);
  const form = box.querySelector(formSelector);

  setDataAttr(btn, "campaign-id", campaignData.id);
  setText(btn, campaignData.cta_text || "View");
  addClass(form, ctaFormClass);
};

const referContainer = ".refer-friend";
const referSuccessMsg = ".refer-friend__success-msg";
const referFormSelector = ".refer-friend__form";
const referEmailsSelector = ".refer-friend__emails";
const pointSelector = ".campaign-box__points.is-points-total";
const referCopyLinkSelector = ".swell-share-referral-copy-link";
const referCopyLinkTextSelector = "#refer-friend__copy-text";
const referCopyLinkCopiedTextSelector = "#refer-friend__copy-text-copied";
const vipContainerSelector = ".rewards-vip";
const greetingSelector = ".rewards__hero-info-title";
const rewardsHistoryButtonSelector = ".rewards .is-history-link";
const checkoutButtonSelector =
  ".rewards-discounts__help-item-actions .is-checkout-btn";

const campaignsWithNoActionMap = {
  YotpoReviewCampaign: true,
  PointsForPurchasesCampaign: true,
  TransactionBasedCampaign: true,
};

// Old yotpo used these names but new api doesnt return that data.
const tierMap = {
  "Nuun+ Fan": "Bronze",
  "Nuun+ Fanatic": "Silver",
  "Nuun+ Fantastic": "Gold",
};

const updateReferFormUI = (step) => {
  const container = qs(referContainer);
  const emailInput = container.querySelector("input.is-email");

  setDataAttr(container, "step", step);

  emailInput.value = "";

  // Updpate email placeholder text
  const placeholder = getAttr(emailInput, `data-placeholder-${step}`);
  emailInput.placeholder = placeholder;

  //
  // Update submit button text
  const submitBtnTextEl = container.querySelector(".button__text");
  const btnText = getAttr(container, `data-btn-text${step}`);
  setText(submitBtnTextEl, btnText);
};

const initReferSection = async () => {
  const form = qs(referFormSelector);
  const container = qs(referContainer);
  const textEl = qs(referCopyLinkTextSelector);
  const textCopiedEl = qs(referCopyLinkCopiedTextSelector);

  click(referCopyLinkSelector, async (_el, e) => {
    e.preventDefault();

    await ensureSwellLoaded();

    const link = window.swellAPI.getCustomerShareReferralLink("copy_link");
    const temp = document.createElement("input");
    document.body.appendChild(temp);
    temp.value = link;
    temp.select();
    document.execCommand("copy");
    document.body.removeChild(temp);

    textEl.style.display = "none";
    fadeIn(textCopiedEl, "inline");

    setTimeout(() => {
      textCopiedEl.style.display = "none";
      textEl.style.display = "inline";
    }, 5000);
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    if (hasClass(form, "is-submitted")) {
      return;
    }

    const emailsInput = qs(referEmailsSelector);
    const emails = emailsInput.value.split(",");
    const step = parseInt(getAttr(container, "data-step"), 10);

    const onStep1Success = () => {
      updateReferFormUI(2);
    };

    if (step === 1) {
      window.swellAPI.identifyReferrer(
        emailsInput.value,
        onStep1Success,
        (e) => {
          alert("Whoop! Please make sure your email is valid.");
        }
      );
      return;
    }

    const onSuccess = () => {
      addClass(referContainer, "is-submitted");
      fadeIn(referSuccessMsg);

      window.setTimeout(() => {
        emailsInput.value = "";
        removeClass(container, "is-submitted");
      }, 5000);
    };

    window.swellAPI.sendReferralEmails(emails, onSuccess, (e) => {
      alert("Whoops! Please make sure the emails are valid addresses.");
    });
  });
};

const hasBirthday = (details) => {
  return details.birth_day && details.birthday_month;
};

const updateCampaignBox = (details, box, campaign, campaignData) => {
  const suffix = box.querySelector(".campaign-box__suffix");
  const points = box.querySelector(".campaign-box__points");
  const text = box.querySelector(".campaign-box__footer-text");
  const desc = box.querySelector(".campaign-box__description");

  if (campaign.rewardPoints === 1) {
    suffix.innerHTML = "Point";
  }

  points.innerHTML = campaign.rewardPoints;
  text.innerHTML = campaign.title;
  desc.innerHTML = campaign.details;

  addClass(box, "is-loaded");

  // If not logged in we won't have this "extra" campaign data
  if (!campaignData) {
    return;
  }

  let isCompleted = campaign.customerCompleted;

  // Special logic for determining if a birthday is "completed"
  if (campaignData.type == "BirthdayCampaign" && hasBirthday(details)) {
    isCompleted = true;
  }

  if (isCompleted) {
    addClass(box, "is-completed");
    return;
  }

  if (campaignData.type === "BirthdayCampaign") {
    initBirthdayForm(box);
    addClass(box, "has-form");
    return;
  }

  // Some campaigns have no action or for, so just skip
  if (campaignsWithNoActionMap[campaignData.type] === true) {
    return;
  }

  initCTAForm(box, campaignData);
  addClass(box, "has-form");
};

const initCampaignUI = (details, campaigns) => {
  const activeCampaigns = window.swellAPI.getActiveCampaigns();
  const map = {};

  campaigns.forEach((campaign) => {
    map[campaign.id] = campaign;
  });

  activeCampaigns.forEach((campaign) => {
    const campaignData = map[campaign.id];
    const boxes = document.querySelectorAll(
      `.campaign-box[data-campaign-id="${campaign.id}"]`
    );

    for (let i = 0; i < boxes.length; i++) {
      updateCampaignBox(details, boxes[i], campaign, campaignData);
    }
  });
};

const initVipTiers = (details, _campaigns) => {
  if (details && "vip_tier_name" in details) {
    const tiers = Object.keys(tierMap);
    const tierKey = tierMap[details.vip_tier_name].toLowerCase();
    const myTier = details.vip_tier_name;

    const container = qs(vipContainerSelector);
    const currentTierEl = qs(`.rewards-vip__tier.${tierKey}-tier`, container);
    const pointsNeeded = details.vip_tier_upgrade_requirements.points_needed;
    const nextPlanEl = qs(".rewards__hero-info-next-plan-msg");

    const mobileTierElements = qsa(
      `.rewards-vip__tiers-row-plan-features.is-${tierKey}-plan`
    );

    let nextTier = null;

    for (let i = 0; i < tiers.length; i++) {
      const vipTier = tiers[i];
      if (vipTier === myTier) {
        nextTier = tiers[i + 1] || null;
        break;
      }
    }

    if (pointsNeeded > 0) {
      //const text =
      //  pointsNeeded === 1
      //    ? "1 Point until next plan"
      //    : `${pointsNeeded} Points until next plan`;
      const text =
        pointsNeeded === 1
          ? `1 point away from ${nextTier}`
          : `${pointsNeeded} points away from ${nextTier}`;
      setText(".rewards-vip__tier-next-level", text);

      if (nextTier) {
        const textFull =
          pointsNeeded === 1
            ? `You're 1 point away from ${nextTier}`
            : `You're ${pointsNeeded} points away from ${nextTier}`;

        setText(nextPlanEl, textFull);
      }
    }

    addClass(currentTierEl, "is-active");
    addClass(mobileTierElements, "is-active");
  }
};

const initGreetingSection = (details, _campaigns) => {
  if (!details.has_store_account) {
    return;
  }

  const name = qs(greetingSelector).innerHTML.trim();
  let message = greetingText(name);
  setText(greetingSelector, message);
  removeClass(greetingSelector, "is-hidden");
};

const initLoyaltyPage = (details, _campaigns) => {
  const formattedPoints = parseInt(details.points_balance).toLocaleString();
  const discountBox = ".rewards-discounts__points .campaign-box";
  const heroPointsBox = ".rewards__hero-campaign.campaign-box";

  setText(pointSelector, formattedPoints);

  addClass(discountBox, "is-loaded");
  addClass(heroPointsBox, "is-loaded");

  click(rewardsHistoryButtonSelector, () => {
    openRewardHistory();
  });

  click(checkoutButtonSelector, () => {
    openCartDrawer();
  });
};

const isLoyaltyPage = () => {
  if (window.location.pathname === "/pages/loyalty-account") {
    return true;
  }

  if (window.location.pathname === "/pages/rewards") {
    return true;
  }

  return false;
};

var initLoyalty = async () => {
  if (isLoyaltyPage()) {
    const rewards = await fetchRewards(window.ShopifyCustomerId);

    initGreetingSection(rewards.customerDetails, rewards.campaigns);
    initLoyaltyPage(rewards.customerDetails, rewards.campaigns);
    initVipTiers(rewards.customerDetails, rewards.campaigns);
    initReferSection();

    $(document).on("swell:setup", function () {
      try {
        initCampaignUI(rewards.customerDetails, rewards.campaigns);
      } catch (e) {
        console.log("Error running campaign ui", e);
      }
    });
  }
};

initLoyalty();
